export default "__VITE_ASSET__Bn1BGxLd__"